import { useCallback, useEffect, useMemo } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getData, getStatus, getErrorMessage } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiStatuses, apiUrls } from "@/store/api/constants";

export default function useSchemeNonEligibleApproval() {
  const {formatMessage} = useIntl();
  
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  // schemesMasterData, schemesMasterStatus, schemesMasterErrMsg

  const schemesMasterData = getData(state, apiKeys.schemesListMasterAll, []);
  const schemesMasterStatus = getStatus(state, apiKeys.schemesListMasterAll, '');
  const schemesMasterErrMsg = getErrorMessage(state, apiKeys.schemesListMasterAll, '');
  const deleteSchemesMasterStatus = getStatus(state, apiKeys.deleteSchemesListMaster, '');
 

  // const getCompetitorMaster = useCallback(() => {
  //   dispatch(fetchData({
  //     url: apiUrls.competitorMaster,
  //     method: apiMethods.GET,
  //     key: apiKeys.competitorMaster,
  //     failureMsg: formatMessage({id: "failed-to-get-competitor-master"}),
  //   }))
  // }, [dispatch, formatMessage])

   const getSchemesListMaster = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.schemesListMasterAll,
      method: apiMethods.GET,
      key: apiKeys.schemesListMasterAll,
      failureMsg: formatMessage({id: "failed-to-get-schemes-list-master"}),
    }))
  }, [dispatch, formatMessage])

  useEffect(() => {
    getSchemesListMaster()
  }, [dispatch, getSchemesListMaster]);

  useEffect(() => {
    if(deleteSchemesMasterStatus === apiStatuses.succeeded){
      getSchemesListMaster();
    }
  }, [deleteSchemesMasterStatus, getSchemesListMaster])

  useEffect(() => ()=> {
    dispatch(clearData({key: apiKeys.schemesListMasterAll}));
  }, [dispatch]);

    return useMemo(() => ({
      schemesMasterData,
      schemesMasterStatus,
      schemesMasterErrMsg,
    }),[
      schemesMasterData,
      schemesMasterStatus,
      schemesMasterErrMsg,
    ])

}

 